import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { WebMitekError } from '../web-mitek-capture/web-mitek-capture.component';

@Component({
  selector: 'web-mitek-capture-modal',
  templateUrl: './web-mitek-capture-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebMitekCaptureModalComponent {
  constructor(private modalCtrl: ModalController) {}

  onCapture(base64: string) {
    this.modalCtrl.dismiss({ success: base64 });
  }

  onError(error: WebMitekError) {
    this.modalCtrl.dismiss({ error });
  }
}
